module.exports = __webpack_public_path__ + "img/neck.2590fe5c.png";